export const WEBSITE_ORIGIN = 'https://getiris.services';
export const APP_ORIGIN = 'https://app.getiris.services';

const normalizeHostname = hostname => String(hostname || '').trim().toLowerCase();

export const isWebsiteHostname = hostname => (
  ['getiris.services', 'www.getiris.services'].includes(normalizeHostname(hostname))
);

export const isAppHostname = hostname => normalizeHostname(hostname) === 'app.getiris.services';

const browserOrigin = () => typeof window === 'undefined' ? '' : window.location.origin;

const isProductionPortalOrigin = origin => {
  try {
    const { hostname } = new URL(origin);
    return isWebsiteHostname(hostname) || isAppHostname(hostname);
  } catch {
    return false;
  }
};

// Patient links retain their established public host when staff move to the app.
// Other hosts keep local, preview and inventory sessions on their own origin.
export const getPatientOrigin = (origin = browserOrigin()) => (
  isProductionPortalOrigin(origin) ? WEBSITE_ORIGIN : origin
);

export const getStaffLoginUrl = (origin = browserOrigin()) => (
  isProductionPortalOrigin(origin) ? `${APP_ORIGIN}/login` : '/login'
);
